import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IVaultServiceWithAccount {
  name: string;
  accountId: number;
  serviceId: number;
  serviceTypeId: number;
}

export interface IServicesState {
  totalCount: number | null;
  isServicesLoading: boolean | null;
  services: IVaultServiceWithAccount[];
}

export const initialState: IServicesState = {
  services: [],
  totalCount: null,
  isServicesLoading: null,
};

export const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    setServices(state, action: PayloadAction<IServicesState['services']>) {
      state.services = action.payload;
    },
    setTotalCount(state, action: PayloadAction<IServicesState['totalCount']>) {
      state.totalCount = action.payload;
    },
    setIsServicesLoading(state, action: PayloadAction<IServicesState['isServicesLoading']>) {
      state.isServicesLoading = action.payload;
    },
    resetServicesState: () => initialState,
  },
});

export const {
  setServices,
  setTotalCount,
  setIsServicesLoading,
  resetServicesState,
} = servicesSlice.actions;

export default servicesSlice.reducer;
